import React from "react";
import { useTranslation } from "react-i18next";
import { variantCategory } from "../../../types/modules/admin/variantCategory.type";
import VariantCategoryItem from "./VariantCategoryItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  variants: variantCategory[];
}

const VariantCategoriesListTable: React.FC<Props> = ({ variants }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateVariantCategory]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {variants.map((variant, index) => (
            <tr
              key={variant.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
             <VariantCategoryItem variant={variant}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default VariantCategoriesListTable;